import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { useProvinces } from "../../../hooks";

const ProvinceSelect = props => {
  const { isLevel2 = false } = props;
  const { t } = useTranslation(["order"]);

  const { data: provinces, refetch: refetchProvinces } = useProvinces({
    countryId: 1,
    type: 1,
    parent_code: "",
    record_status: isLevel2 ? "O" : "C",
  });

  useEffect(() => {
    refetchProvinces();
  }, [isLevel2]);

  const options = [];
  for (const key in provinces) {
    options.push({
      label: provinces[key],
      value: key,
    });
  }

  if (props.value && !props.value.label) {
    props.value.label = options.find(e => e.value == props.value.value)?.label;
  }

  return (
    <Select
      {...props}
      placeholder={t("placeholder.select", {
        title: t("form.receiver_province_code"),
      })}
      options={options}
      classNamePrefix="select2-selection"
    />
  );
};

export default ProvinceSelect;
